import React from 'react';
import styles from "./InMemoriamLandingPageContent.module.css";
import ArticleElement from '../../../../components/ArticleElement/ArticleElement';
import LoadingAnimation from '../../../../components/LoadingAnimation/LoadingAnimation';
import GridDetail from '../../../../components/MainGrid/GridDetail/GridDetail';

const InMemoriamLandingPageContent = ({title, children, articles}) => {
    return (
        <>
            <article className={styles.InMemoriamLandingPageContent}>
                <div className="container">
                    <h1 className={styles.title}>{title}</h1>
                    <div className={styles.blurb}>
                        {children}
                    </div>
                    <div className={styles.InMemoriamArticles}>
                        {articles.map(article => {
                                return (
                                    <ArticleElement
                                        type="inMemoriam"
                                        item={article}
                                        cta="Read tribute"
                                        backgroundColor="transparent"
                                        key={`in-memoriam-${article.slug}`}
                                        backRef={'/people/in-memoriam/'}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </article>
        </>
    )
}
export default InMemoriamLandingPageContent
